import { Dispatch } from 'redux';
import { Moment } from 'moment';

import { fetcher } from '../../lib/request';

import { SearchParams } from '../../models/Food/SearchParams';

const FOOD_HOST = process.env.REACT_APP_FOOD_HOST;
const FOOD_KEY = process.env.REACT_APP_FOOD_KEY;

export const SET_FOOD_PERSONS = 'FOOD_SET_FOOD_PERSONS';
export const SET_FOOD_TIME = 'FOOD_SET_FOOD_TIME';
export const SET_FOOD_COMMENT = 'FOOD_SET_FOOD_COMMENT';

export const RESERVATION_REQUEST = 'FOOD_RESERVATION_REQUEST';
export const RESERVATION_RESPONSE = 'FOOD_RESERVATION_RESPONSE';
export const RESERVATION_ERROR = 'FOOD_RESERVATION_ERROR';

export const CONFIRMATION_REQUEST = 'FOOD_CONFIRMATION_REQUEST';
export const CONFIRMATION_RESPONSE = 'FOOD_CONFIRMATION_RESPONSE';
export const CONFIRMATION_ERROR = 'FOOD_CONFIRMATION_ERROR';

export const RESET_ORDER = 'FOOD_RESET_ORDER';

export const resetOrderAction = () => (dispatch: Dispatch<any>) => {
    return dispatch({
        type: RESET_ORDER
    });
};

export const setPersonsAction = (num: number) => (dispatch: Dispatch<any>) => {
    return dispatch({
        type: SET_FOOD_PERSONS,
        num
    });
};

export const setDateTimeAction = (datetime: Moment) => (dispatch: Dispatch<any>) => {
    return dispatch({
        type: SET_FOOD_TIME,
        datetime
    });
};

export const setCommentAction = (comment: string) => (dispatch: Dispatch<any>) => {
    return dispatch({
        type: SET_FOOD_COMMENT,
        comment
    });
};

export const confirmReservationAction = (code: string, id: string, userId: string) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: CONFIRMATION_REQUEST
    });

    try {
        const data = {
            user_id: userId,
            sms_code: code
        };

        const response = await fetcher(`${FOOD_HOST}/v1/reservations/${id}/confirm`)
            .post(data)
            .contentType('application/json')
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        if ((response as any).result) {
            dispatch({
                type: CONFIRMATION_RESPONSE,
                response
            });
        } else {
            dispatch({
                type: CONFIRMATION_ERROR
            });
        }
    } catch (error) {
        dispatch({
            type: CONFIRMATION_ERROR,
            error
        });
    }
};

export const createReservationAction = (
    params: SearchParams,
    phone: string,
    name: string,
    id: number,
    user_id: string
) => async (dispatch: Dispatch<any>) => {
    dispatch({
        type: RESERVATION_REQUEST
    });

    try {
        const data = {
            user_id: user_id,
            phone: phone,
            visitors: params.persons,
            name: name,
            reservation_date: params.datetime!.format('YYYY-MM-DD HH:mm:00'),
            restaurant_id: id,
            source_id: 'APPLE_CONCIERGE',
            partner_id: 'AFISHA',
            comment: params.comment
        };

        const response = await fetcher(`${FOOD_HOST}/v1/reservations/create`)
            .post(data)
            .contentType('application/json')
            .auth(`Basic ${FOOD_KEY}`)
            .json();

        dispatch({
            type: RESERVATION_RESPONSE,
            response
        });
    } catch (error) {
        dispatch({
            type: RESERVATION_ERROR,
            error
        });
    }
};



// WEBPACK FOOTER //
// ./src/actions/Food/order.ts